var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup38146(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38146",
    "data-name": "Group 38146",
    transform: "translate(-1610 -2177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "minus",
    d: "M4.5,15.75h30v4H4.5Z",
    transform: "translate(1605.5 2174.25)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "minus-2",
    "data-name": "minus",
    d: "M4.5,15.75h30v4H4.5Z",
    transform: "translate(1642.75 2172.5) rotate(90)",
    fill: "#0267c1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup38146);
export default __webpack_public_path__ + "static/media/Group 38146.9bb3103b33faae453791c7bea9f0075d.svg";
export { ForwardRef as ReactComponent };